const layout = () => import('../../internal/dashboard/layoutV2.vue')
const buyCredit = () => import('./buyCreditV2.vue')

const buyCreditRoutes = {
  component: layout,
  children: [
    {
      path: '/buyCredit',
      name: 'buyCredit',
      meta: {
        title: 'buyCredit',
        requiresAuth: true,
      },
      component: buyCredit,
    },
  ],
}

export default buyCreditRoutes
